import { useState } from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { Button } from '../../../../FormStyles/Button';
import { TILE_BUTTON_CHARACTERS_LIMIT } from '../../../data';
import i18n from '../../../../../app/i18n';
import defaultAttrs from '../../../../../lib/utils/defaultAttrs';

const TileButton = ({
  buttonText,
  withRadio,
  isRemovable,
  onRemove,
  onChangeButtonText,
  buttonIndex,
  correctAnswerIndex,
}) => {
  const [isEditingButton, setIsEditingButton] = useState(false);

  const handleSelect = ({ target }) => {
    target.select();
  };

  return isEditingButton ? (
    <>
      <TileButtonEdit
        name={`answers[${buttonIndex}]`}
        rows="1"
        maxLength={TILE_BUTTON_CHARACTERS_LIMIT}
        onBlur={() => setIsEditingButton(false)}
        onChange={onChangeButtonText}
        autoFocus
        onFocus={handleSelect}
        value={buttonText}
        onKeyDown={event => {
          if (event.keyCode === 13) {
            event.preventDefault();
            event.target.blur();
          }
        }}
      ></TileButtonEdit>
      <TileButtonTextCounter>
        {`${TILE_BUTTON_CHARACTERS_LIMIT - buttonText?.length} ${i18n.t(
          'tileForm:charactersLeft',
        )}`}
      </TileButtonTextCounter>
    </>
  ) : (
    <TileButtonWrapper>
      {withRadio && (
        <TileRadioWrapper>
          <TileRadioInput
            type="radio"
            name="correctAnswerIndex"
            checked={buttonIndex === Number(correctAnswerIndex)}
            value={buttonIndex}
            onChange={e =>
              onChangeButtonText({
                target: {
                  value: Number(e.target.value),
                  name: 'correctAnswerIndex',
                },
              })
            }
          />
        </TileRadioWrapper>
      )}
      <>
        <TileButtonDisplay
          variant="answerBlue"
          onClick={() => setIsEditingButton(true)}
        >
          {buttonText}
          <TileButtonIcon />
        </TileButtonDisplay>
        {isRemovable && (
          <RemoveIcon
            onClick={() => onRemove(buttonIndex)}
            data-testid="remove-answer"
          />
        )}
      </>
    </TileButtonWrapper>
  );
};

export default TileButton;

const RemoveIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-solid fa-xmark',
  }),
)`
  width: 10px;
  margin-left: 10px;
  cursor: pointer;
`;

const TileButtonTextCounter = styled.div`
  margin-top: 0;
  margin-bottom: 10px;
  color: #a8a8a8;
  font-size: 10px;
  float: right;
`;

const TileButtonEdit = styled.textarea`
  overflow-x: 'hidden';
  overflow-wrap: 'break-word';
  color: ${themeGet('colors.primary.100')};
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.white')};
  text-align: center;
  font-size: 1.25em;
  min-height: 45px;
  overflow: visible;
  resize: none;
  margin: 0 10px 20px;
  padding: 0.5em;
  outline: 0;
  border-radius: 4px;
  appearance: none;
  box-shadow: none;
  vertical-align: top;
  height: auto;
`;

const TileRadioInput = styled.input`
  cursor: pointer;
`;

const TileRadioWrapper = styled.div`
  display: inline-block;
  padding: 12px 0px;
  background-color: ${themeGet('colors.black.20')};
  width: 8%;
  margin-right: 10px;
  text-align: center;
  border-radius: 4px;
  line-height: 1.35em;
  vertical-align: bottom;
`;

const TileButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0px;
  position: relative;
  clear: both;
  font-weight: normal;
`;

const TileButtonDisplay = styled(Button)`
  background: linear-gradient(
    253.58deg,
    ${themeGet('colors.primary.70')} 1.55%,
    ${themeGet('colors.primary.100')} 95.8%
  );
  padding: 10px 20px;
  position: relative;
  clear: both;
  font-weight: normal;
  width: 100%;
  font-size: 20px;
  line-height: 25px;
  min-height: 45px;

  &:hover {
    background: linear-gradient(
      253.58deg,
      ${themeGet('colors.primary.70')} 1.55%,
      ${themeGet('colors.primary.80')} 95.8%
    );
  }
  &:active {
    box-shadow: none;
  }
`;

const TileButtonIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-regular fa-pencil',
  }),
)`
  float: right;
  width: 20px;
`;
